module.exports = __webpack_public_path__ + "static/media/f1s.bd3fae13.svg";